import React, {
  useRef,
  useState,
  Fragment,
  useEffect,
  useCallback,
} from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import { db } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import dev from "../../assets/images/dev.png";
import bg from "../../assets/images/small.png";

function InviteMentors() {
  const emailRef = useRef();
  const nameRef = useRef();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [noInvite, setNoInvite] = useState("");
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();
  let [isOpen, setIsOpen] = useState(true);

  function closeModal() {
    setIsOpen(false);
  }

  function onSubmit() {
    setError("");
    setLoading(true);
    const promises = [];
    if (user.invites > 0) {
      promises.push(
        db.collection("invitedMentors").doc(emailRef.current.value).set({
          name: nameRef.current.value,
          email: emailRef.current.value,
        })
      );
      promises.push(
        db
          .collection("mentors")
          .doc(currentUser.uid)
          .update({
            invites: user.invites - 1,
          })
      );

      Promise.all(promises)
        .then(() => {
          setSuccess(`Successfully invited ${nameRef.current.value}`);
          fetchUserData();
          nameRef.current.value = "";
        })
        .catch(() => {
          setError("Failed to update the information");
        })
        .finally(() => {
          setLoading(false);
        });
      emailRef.current.value = "";
    } else {
      setNoInvite("No invites left");
      setLoading(false);
    }
  }
  const fetchUserData = useCallback(async () => {
    return await db
      .collection("mentors")
      .doc(currentUser.uid)
      .get()
      .then((doc) => {
        let newUserState = {
          invites: doc.data().invites,
        };
        setUser(newUserState);
      });
  }, [currentUser.uid]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <div>
      <Header />
      <div className="container mx-auto sm:py-24 sm:px-2 ">
        <div className="mt-10 sm:-mt-12">
          <div className="md:grid md:grid-cols-1 md:gap-6"></div>
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium max-w-prose text-gray-500">
                <Link to="/mentor/dashboard">Account</Link> &nbsp; &gt; &nbsp;
                Invite Mentors
              </h3>
              <h3 className="text-3xl mt-4 font-bold leading-relaxed text-gray-900">
                Invite Mentors
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div className="container w-full mx-auto px-4 sm:px-2 sm:-mt-16 mb-20">
        <div class="p-2 sm:p-4  w-full flex flex-col justify-center sm:flex-row  mx-auto sm:divide-x-4 divide-gray-300 divide-dashed ">
          <div className="bg-gray-200 p-2 rounded-3xl ">
            <a
              className="block object-cover rounded-lg p-5 h-full"
              style={{
                backgroundImage: `url(${bg})`,
              }}
              href
            >
              <div class=" h-48 sm:h-full sm:w-72 rounded-3xl sm:p-8 object-cover justify-center overflow-hidden mx-auto flex items-center  ">
                <img
                  src={dev}
                  alt=""
                  className="object-cover rounded-xl p-24 sm:p-8 "
                />
              </div>
            </a>
          </div>
          <div className="bg-gray-200 sm:w-2/3 p-2 rounded-3xl">
            <a
              className="block object-cover  rounded-lg p-5  h-full"
              style={{
                backgroundImage: `url(${bg})`,
                backgroundPosition: "center",
              }}
              href
            >
              <div class=" flex flex-col flex-1 gap-5 p-4 sm:p-8 rounded-3xl w-full">
                <div class="flex flex-1 flex-col gap-3">
                  <div class=" w-full font-bold text-2xl rounded-2xl">
                    Send Invitation 🎉
                  </div>
                  <div class=" w-full h-3 rounded-2xl">
                    <div class="relative mb-4 mt-4">
                      <label
                        for="full-name"
                        class="leading-7 text-lg font-semibold text-gray-800"
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="full-name"
                        ref={nameRef}
                        name="full-name"
                        autoComplete="given-name"
                        required
                        class="w-full bg-white  rounded border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                      />
                    </div>
                  </div>
                  <div class="relative mt-20">
                    <label
                      for="email"
                      class="leading-7 text-lg font-semibold  text-gray-800"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      required
                      ref={emailRef}
                      name="email"
                      class="w-full bg-white rounded border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                    <p class="text-sm font-semibold text-gray-800 mt-4">
                      Total invites left: {user.invites}
                    </p>
                  </div>
                  <div className="text-right ">
                    <button
                      onClick={onSubmit}
                      class=" border-0 py-2 px-4 text-white bg-gradient-to-r from-blue-500 to-blue-900 rounded text-base"
                      disabled={loading}
                    >
                      {!loading && <div>Send invite</div>}
                      {loading && (
                        <div className="w-full justify-center flex animate-pulse">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                            />
                          </svg>
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* <div class="container px-4  mx-auto flex flex-wrap items-top mt-4 sm:-mt-16">
        <div class="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0">
          <p class="leading-relaxed text-sm sm:text-lg">
            As you know we're still opening up but anyone can join with an
            invite from an existing mentor like you! You can invite total three
            mentors using this superpower and before inviting someone please go
            through the points mentioned below.
          </p>
          <div class="mt-8 sm:w-1/2 w-full">
            <div class="bg-gray-100 rounded-lg flex p-4 h-full items-center">
              <svg
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                class="text-blue-600 w-6 h-6 flex-shrink-0 mr-4"
                viewBox="0 0 24 24"
              >
                <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                <path d="M22 4L12 14.01l-3-3"></path>
              </svg>
              <span class="title-font font-medium">
                You know the mentor closely
              </span>
            </div>
          </div>
          <div class="mt-4 sm:w-1/2 w-full">
            <div class="bg-gray-100 rounded-lg flex p-4 h-full items-center">
              <svg
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                class="text-blue-600 w-6 h-6 flex-shrink-0 mr-4"
                viewBox="0 0 24 24"
              >
                <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                <path d="M22 4L12 14.01l-3-3"></path>
              </svg>
              <span class="title-font font-medium">
                You worked with the mentor in past
              </span>
            </div>
          </div>
        </div>
        <div class="lg:w-2/6 md:w-1/2 bg-red-400 rounded-full items-bottom md:ml-auto h-24">
          <div className="bg-black rounded mt-20 mx-4 outline-black"></div>
        </div>
        <div class="lg:w-2/6 md:w-1/2 bg-red-400 rounded-3xl p-8 flex flex-col md:ml-auto w-full mt-10 sm:-mt-40">
          <h2 class="text-white text-lg font-medium title-font mb-5">
            Send Invitation 🎉
          </h2>
          <div class="relative mb-4">
            <label for="full-name" class="leading-7 text-sm text-white">
              Full Name
            </label>
            <input
              type="text"
              id="full-name"
              ref={nameRef}
              name="full-name"
              autoComplete="given-name"
              required
              class="w-full bg-white rounded border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div class="relative mb-4">
            <label for="email" class="leading-7 text-sm text-white">
              Email
            </label>
            <input
              type="email"
              id="email"
              required
              ref={emailRef}
              name="email"
              class="w-full bg-white rounded border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <button
            onClick={onSubmit}
            class=" border-0 py-2 px-8 text-white bg-red-600 rounded text-lg"
            disabled={loading}
          >
            {!loading && <div>Invite</div>}
            {loading && (
              <div className="w-full justify-center flex animate-pulse">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                  />
                </svg>
              </div>
            )}
          </button>
          <p class="text-sm text-white mt-4">
            Total invites left: {user.invites}
          </p>
        </div>
      </div> */}

      {error && (
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={closeModal}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>
              <span
                className="inline-block relative align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block flex justify-between absolute right-6  bottom-0  max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <div className="flex items-center">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 bg-red-500 rounded-full"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="white"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <Dialog.Title
                        as="h3"
                        className="text-sm font-base text-gray-900 ml-2 mr-6"
                      >
                        Something is wrong! Please try after some time.
                      </Dialog.Title>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="flex absolute text-black rounded-md focus:outline-none"
                      onClick={closeModal}
                    >
                      <span className="sr-only">Dismiss</span>
                      <XIcon
                        className="h-5 w-6 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      )}

      {success && (
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={closeModal}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>
              <span
                className="inline-block relative align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block flex justify-between absolute right-6  bottom-0  max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <div className="flex items-center">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 text-green-500"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <div>
                      <Dialog.Title
                        as="h3"
                        className="text-sm font-base text-gray-900 ml-2 mr-6"
                      >
                        {success}
                      </Dialog.Title>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="flex absolute text-black rounded-md focus:outline-none"
                      onClick={closeModal}
                    >
                      <span className="sr-only">Dismiss</span>
                      <XIcon
                        className="h-5 w-6 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      )}

      {noInvite && (
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={closeModal}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>
              <span
                className="inline-block relative align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block flex justify-between absolute right-6  bottom-0  max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <div className="flex items-center">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 bg-yellow-500 rounded-full"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="yellow"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <Dialog.Title
                        as="h3"
                        className="text-sm font-base text-gray-900 ml-2 mr-6"
                      >
                        {noInvite}
                      </Dialog.Title>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="flex absolute text-black rounded-md focus:outline-none"
                      onClick={closeModal}
                    >
                      <span className="sr-only">Dismiss</span>
                      <XIcon
                        className="h-5 w-6 text-gray-400"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      )}
    </div>
  );
}

export default InviteMentors;
